
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/membership",
      function () {
        return require("private-next-pages/membership/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/membership"])
      });
    }
  